import { createContext } from '../create-context';
export const [EnvironmentProvider, useEnvironmentContext] = createContext({
    hookName: 'useEnvironmentContext',
    providerName: '<EnvironmentProvider />',
    strict: false,
});
